export const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1440,
};

export const media = {
  sm: `(min-width: ${breakpoints.sm}px)`,
  md: `(min-width: ${breakpoints.md}px)`,
  lg: `(min-width: ${breakpoints.lg}px)`,
  xl: `(min-width: ${breakpoints.xl}px)`,
  maxSm: `(max-width: ${breakpoints.sm - 1}px)`,
  maxMd: `(max-width: ${breakpoints.md - 1}px)`,
  maxLg: `(max-width: ${breakpoints.lg - 1}px)`,
  maxXl: `(max-width: ${breakpoints.xl - 1}px)`,
};

export type Breakpoint = keyof typeof media;

import { css } from 'styled-components';

export const hideOnPhone = () => css`
  @media ${media.maxSm} {
    display: none;
  }
`;
